<template>
  <v-row no-gutters class="my-2" style="margin-left: 3%;">
    <v-col cols="12">
      <v-card outlined style="max-width: 400px;">
        <DataTable
        hideHeader
        disablePagination
        containerClass="pa-0"
        tableKey="bidCostTypeId"
        :items="costComponents"
        :headers="headers"
        :sumHeaders="['rate']"
        :showTotals="showTotal"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BidHeaders from '@/headers/Bid.js'

export default {
  name: 'BidCostComponentTable',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue')
  },

  props: {
    costComponents: {
      type: Array,
      default: () => []
    },
    hideTotal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    headers () {
      return BidHeaders.bidCostComponentHeaders()
    },

    showTotal () {
      return !this.hideTotal && this.costComponents.length > 1
    }
  }
}
</script>
